var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrash(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.58579 0.585786C5.96086 0.210714 6.46957 0 7 0H11C11.5304 0 12.0391 0.210714 12.4142 0.585786C12.7893 0.960859 13 1.46957 13 2V4H17C17.5523 4 18 4.44772 18 5C18 5.55228 17.5523 6 17 6H16.9311L16.1305 17.213C16.1305 17.2131 16.1305 17.2129 16.1305 17.213C16.0765 17.9698 15.7379 18.6783 15.1826 19.1954C14.6274 19.7125 13.8968 20 13.138 20H4.86202C4.10323 20 3.37262 19.7125 2.81735 19.1954C2.26213 18.6783 1.92347 17.97 1.86954 17.2132C1.86953 17.2132 1.86955 17.2133 1.86954 17.2132L1.06886 6H1C0.447715 6 0 5.55228 0 5C0 4.44772 0.447715 4 1 4H5V2C5 1.46957 5.21071 0.960859 5.58579 0.585786ZM7 4H11V2H7V4ZM3.07395 6L3.86446 17.0708C3.88242 17.3231 3.99533 17.5594 4.18042 17.7318C4.36551 17.9042 4.60905 18 4.862 18H13.138C13.391 18 13.6345 17.9042 13.8196 17.7318C14.0047 17.5594 14.1176 17.3233 14.1355 17.071L14.926 6H3.07395ZM7 8C7.55228 8 8 8.44772 8 9V15C8 15.5523 7.55228 16 7 16C6.44772 16 6 15.5523 6 15V9C6 8.44772 6.44772 8 7 8ZM11 8C11.5523 8 12 8.44772 12 9V15C12 15.5523 11.5523 16 11 16C10.4477 16 10 15.5523 10 15V9C10 8.44772 10.4477 8 11 8Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.3aaa2c85539e61dec04c111469b9fe54.svg";
export { ForwardRef as ReactComponent };